import { AppKey, useAuthentication, useAuthTokenUpdater } from '@scoring/logic';
import { DefaultLoader, NotFoundPage, ProtectedOutlet } from '@scoring/ui';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router';
import { headJudgeRoutes } from './areas/headJudge/routes';
import { identityRoutes } from './areas/identity/routes';
import { judgeRoutes } from './areas/judge/routes';
import { managerRoutes } from './areas/manager/routes';
import { LandingPage } from './shell/LandingPage';
import { RequireApp } from './shell/RequireApp';

// Auth-aware layout routes read the auth store directly so the route tree can be built once, at
// module scope. A data router (createBrowserRouter) is required for navigation blocking (see
// useUnsavedChangesGuard).

const ProtectedRoute = () => {
    const { user } = useAuthentication();
    const renewingExpiredToken = useAuthTokenUpdater();
    if (renewingExpiredToken && user) return <DefaultLoader />;
    return <ProtectedOutlet user={user} />;
};

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route hydrateFallbackElement={<DefaultLoader />}>
            {identityRoutes}
            <Route element={<ProtectedRoute />}>
                <Route index element={<LandingPage />} />
                <Route element={<RequireApp app={AppKey.Manager} />}>{managerRoutes}</Route>
                <Route element={<RequireApp app={AppKey.Judge} />}>{judgeRoutes}</Route>
                <Route element={<RequireApp app={AppKey.HeadJudge} />}>{headJudgeRoutes}</Route>
            </Route>
            <Route path="*" element={<NotFoundPage />} />
        </Route>
    )
);

export function Router() {
    return <RouterProvider router={router} />;
}
